import './CloseButton.css';
import React from 'react';
import { IconClose } from '../../04_Audio/icons';
import { IconCloseCircle } from '../Icons';
export var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    isCircleButton = _ref.isCircleButton;
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": "Close" //TODO: remove hardcode
    ,

    className: "".concat(commonStyles, " ").concat(className ? className : ''),
    onClick: onClick
  }, isCircleButton ? /*#__PURE__*/React.createElement(IconCloseCircle, {
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement(IconClose, {
    className: "default-icon",
    "aria-hidden": "true"
  }));
};
var commonStyles = "cxuz672";